import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/query-key.const';
import { HttpException } from '../../../../exceptions/index';
import { useAppMutation } from '../../../../hooks/use-app-mutation.hook';
import ApiService from '../../../../services/api-service.util';

export const useDownloadSignatureDocument = (): {
  download: (signatureId: string) => Promise<void>;
  isDownloadPending: boolean;
} => {
  const { isPending: isDownloadPending, mutateAsync: download } = useAppMutation<
    void,
    HttpException,
    string
  >([QueryKey.DOWNLOAD_SIGNATURE_DOCUMENT], {
    mutationFn: (signatureId: string) =>
      ApiService.downloadFile({
        endpoint: BackendRoute.SIGNATURES,
        routePath: [signatureId, 'download'],
      }),
  });

  return { download, isDownloadPending };
};
